import { Grid, styled } from "@mui/material";

const PageGrid = styled(Grid)(() => ({
  minHeight: "91vh",
  margin: "5vh 0 20vh 0"
}));

export { PageGrid };
